import React from "react";
import { Container, Row, Col } from "@ui/wrapper";
import Heading from "@ui/heading";
//import SwiperSlider, { SwiperSlide } from "@ui/swiper";
import Image from "@ui/image";
// import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./index.css";
import { SectionWrap, SubTitle } from "./style";

// import "./style.css";
/* const sliderSettings = {
    slidesPerView: 1,
    loop: true,
    autoplay: true,
    breakpoints: {
        600: {
            slidesPerView: 3,
        },
        800: {
            slidesPerView: 4,
        },
        1000: {
            slidesPerView: 5,
        },
        1200: {
            slidesPerView: 6,
        },
    },
};
 */
const CarouselSlider = ({ data }) => {
    console.log("图片", data.items);
    return (
        <SectionWrap>
            <SubTitle>一个管理各种类别资产的云平台</SubTitle>

            <Container padding={0}>
                <div class="slide">
                    <ul class="list">
                        {data.items.map((it, idx) => {
                            if (idx < 5) {
                                return (
                                    <li class="item">
                                        {it.images[0]?.src && (
                                            <Image
                                                src={it.images[0].src}
                                                alt={it.images[0]?.alt || it.id}
                                            />
                                        )}
                                    </li>
                                );
                            }
                        })}
                        {data.items.map((it, idx) => {
                            if (idx < 5) {
                                return (
                                    <li class="item">
                                        {it.images[0]?.src && (
                                            <Image
                                                src={it.images[0].src}
                                                alt={it.images[0]?.alt || it.id}
                                            />
                                        )}
                                    </li>
                                );
                            }
                        })}
                    </ul>
                </div>
            </Container>
        </SectionWrap>
    );
};

export default CarouselSlider;
